import React, { Fragment, useContext, useEffect, useState } from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import {
  Grid,
  TextField,
  FormControl,
  Paper,
  Select,
  MenuItem,
} from "@material-ui/core/";
import DataContext from "../DataContext";
import * as questionTypes from "./question-types";
import "../index.css";

interface IProps {
  type: string;
  question: string;
  help: string;
  id: number;
  choices: string[];
  putAnswerCallback: (id: number, choice: string, answer: string) => void;
  carbonQuestion: boolean;
  orgInfoQuestion: boolean;
  index: number;
  example_img?: string;
}

export const GenerateQuestion: React.FC<IProps> = (props: IProps) => {
  switch (props.type) {
    case questionTypes.TEXT:
      return <TextQuestion {...props} />;
    case questionTypes.NUMBER:
      return <NumberQuestion {...props} />;
    case questionTypes.CATEGORY:
      return <CategoryQuestion {...props} />;
    case questionTypes.TOGGLE:
      return <ToggleQuestion {...props} />;
  }
  return <div>unknown type of question</div>;
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    width: 300,
    margin: 100,
  },
  //style for font size
  resize: {
    fontSize: 50,
  },
};

const TextQuestion: React.FC<IProps> = (props: IProps) => {
  let xs_size_number = 12;
  let xs_size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = 1;
  if (props.choices.length > 0) {
    // xs_size_number = Math.floor(xs_size_number / props.choices.length);
    xs_size_number = props.choices.length;
  }
  switch (xs_size_number) {
    case 1:
      xs_size = 12;
      break;
    case 2:
      xs_size = 6;
      break;
    case 3:
      xs_size = 4;
      break;
    case 4:
      xs_size = 3;
      break;
    case 5:
      xs_size = 2;
      break;
    case 6:
      xs_size = 2;
      break;
    case 7:
      xs_size = 1;
      break;
  }
  return (
    <Fragment>
      <Grid style={{ color: "#595959" }} item xs={7}>
        {props.question}
        <br />
        <span className="helptext">{props.help}</span>
      </Grid>
      {props.example_img ? (
        <img src={props.example_img} style={{ width: "100%" }} />
      ) : null}
      {props.index > 0 ? (
        // <div style={{ color: "red" }}>{props.index}</div>
        <Grid item xs={5} container spacing={1}>
          <Grid item xs={1}>
            <div
              style={{
                height: "100%",
              }}
            >
              <div
                style={{
                  padding: 5,
                  background: "#c1d300",
                  color: "white",
                  margin: "auto",
                  height: "60%",
                }}
              >
                <span style={{ margin: "auto" }}> {props.index}</span>
              </div>
            </div>
          </Grid>
          <Grid item xs={11} container spacing={1}>
            {props.choices.map((choice: string) => {
              return (
                <Grid key={choice + props.id.toString()} item xs={xs_size}>
                  {TextBoxWithAnswer(
                    choice,
                    props.id,
                    props.putAnswerCallback,
                    props.carbonQuestion,
                    props.orgInfoQuestion
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={5} container>
          {props.choices.map((choice: string) => {
            return (
              <Grid key={choice + props.id.toString()} item xs={xs_size}>
                {TextBoxWithAnswer(
                  choice,
                  props.id,
                  props.putAnswerCallback,
                  props.carbonQuestion,
                  props.orgInfoQuestion
                )}
              </Grid>
            );
          })}
        </Grid>
      )}
    </Fragment>
  );
};

const NumberQuestion: React.FC<IProps> = (props: IProps) => {
  let xs_size_number = 12;
  let xs_size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = 1;
  if (props.choices.length > 0) {
    // xs_size_number = Math.floor(xs_size_number / props.choices.length);
    xs_size_number = props.choices.length;
  }
  switch (xs_size_number) {
    case 1:
      xs_size = 12;
      break;
    case 2:
      xs_size = 6;
      break;
    case 3:
      xs_size = 4;
      break;
    case 4:
      xs_size = 3;
      break;
    case 5:
      xs_size = 2;
      break;
    case 6:
      xs_size = 2;
      break;
    case 7:
      xs_size = 1;
      break;
  }
  return (
    <Fragment>
      <Grid style={{ color: "#595959" }} item xs={7}>
        {props.question}
        <br />
        <span className="helptext">{props.help}</span>
      </Grid>

      <Grid item xs={5} container>
        {props.choices.map((choice: string) => {
          return (
            <Grid key={choice + props.id.toString()} item xs={xs_size}>
              {TextBoxWithAnswer(
                choice,
                props.id,
                props.putAnswerCallback,
                props.carbonQuestion,
                props.orgInfoQuestion
              )}
            </Grid>
          );
        })}
      </Grid>
      {props.example_img ? (
        <img src={props.example_img} style={{ width: "100%" }} />
      ) : null}
    </Fragment>
  );
};

const CategoryQuestion: React.FC<IProps> = (props: IProps) => {
  const context = useContext(DataContext);
  let answers: Answer[] = [];
  if (props.carbonQuestion) {
    answers = context.carbonAnswers;
  } else if (props.orgInfoQuestion) {
    answers = context.orgInfoAnswers;
  } else {
    answers = context.answers;
  }
  const defaultAnswer = answers.find((x) => x.questionId === props.id);
  return (
    <Fragment>
      <Grid style={{ color: "#595959" }} item xs={7}>
        {props.question}
        <br />
        <span className="helptext">{props.help}</span>
        {props.example_img ? (
          <img src={props.example_img} style={{ width: "100%" }} />
        ) : null}
      </Grid>
      <Grid item xs={5}>
        <FormControl fullWidth variant="outlined" size="small">
          <Select
            defaultValue={defaultAnswer ? defaultAnswer.answer : null}
            onChange={(e) => {
              props.putAnswerCallback(
                props.id,
                "category",
                e.target.value as string
              );
            }}
          >
            {props.choices.map((choice: string) => {
              return (
                <MenuItem key={choice + props.id.toString()} value={choice}>
                  {choice}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
    </Fragment>
  );
};

const ToggleQuestion: React.FC<IProps> = (props: IProps) => {
  const context = useContext(DataContext);
  let answers: Answer[] = [];
  if (props.carbonQuestion) {
    answers = context.carbonAnswers;
  } else if (props.orgInfoQuestion) {
    answers = context.orgInfoAnswers;
  } else {
    answers = context.answers;
  }
  let defaultAnswer = answers.find((x) => x.questionId === props.id);
  const [value, setValue] = React.useState<string | null>(
    defaultAnswer ? defaultAnswer.answer : null
  );
  useEffect(() => {
    defaultAnswer = answers.find((x) => x.questionId === props.id);
    if (defaultAnswer) {
      setValue(defaultAnswer.answer);
    }
  }, [answers]);

  return (
    <Fragment>
      <Grid style={{ color: "#595959" }} item xs={7}>
        {props.question}
        <br />
        <span className="helptext">{props.help}</span>
        {props.example_img ? (
          <img src={props.example_img} style={{ width: "100%" }} />
        ) : null}
      </Grid>
      <Grid
        item
        xs={
          props.choices.find((choice: string) => choice.includes("image/png"))
            ? 12
            : 5
        }
      >
        <ToggleButtonGroup
          size="small"
          style={{ width: "100%" }}
          value={value}
          onChange={(e, newValue) => {
            props.putAnswerCallback(props.id, "toggle", newValue.toString());
            setValue(newValue);
          }}
          exclusive
        >
          {props.choices.map((choice: string) => {
            return (
              <ToggleButton
                style={{ width: "100%" }}
                key={choice + props.id.toString()}
                value={choice}
              >
                {choice.includes("image/png") ? (
                  <div>
                    <img src={choice.split("@")[0]} style={{ width: "100%" }} />
                    {choice.split("@")[1]}
                  </div>
                ) : (
                  choice
                )}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Grid>
    </Fragment>
  );
};
const TextBoxWithAnswer = (
  choice: string,
  questionId: number,
  putAnswerCallback: (id: number, choice: string, answer: string) => void,
  carbonQuestion: boolean,
  orgInfoQuestion: boolean
) => {
  const context = useContext(DataContext);
  let answers: Answer[] = [];
  if (carbonQuestion) {
    answers = context.carbonAnswers;
  } else if (orgInfoQuestion) {
    answers = context.orgInfoAnswers;
  } else {
    answers = context.answers;
  }
  const defaultAnswer = answers.find(
    (x) => x.choice === choice && x.questionId == questionId
  );
  const [value, setValue] = useState<string | null>(
    defaultAnswer ? defaultAnswer.answer : null
  );

  useEffect(() => {
    const newAnswer = answers.find(
      (x) => x.questionId === questionId && x.choice == choice
    );
    if (newAnswer) {
      setValue(newAnswer.answer);
    }
  }, [answers]);
  return (
    <TextField
      value={value}
      size="small"
      label={value ? null : choice}
      fullWidth
      variant="outlined"
      InputLabelProps={{
        style: {
          fontSize: "0.8125rem",
          fontWeight: 500,
          color: "rgba(0,0,0,0.38)",
        },
      }}
      inputProps={{
        style: {
          fontSize: "0.8125rem",
          fontWeight: 500,
          color: "rgba(0,0,0,0.98)",
        },
      }}
      onChange={(e) => {
        setValue(e.target.value);
        putAnswerCallback(questionId, choice, e.target.value);
      }}
    />
  );
};
